import createCustomElement from '../../wrapper/custom-element';
import checkbox from './checkbox.vue';
export default createCustomElement(checkbox);
